<template>
  <div class="animated fadeIn">
    <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
    <b-card v-else>
      <Timer :formattedTime="formattedTime" />
      <template v-slot:header>
        <h5>Input Gadai Emas</h5>
      </template>
      <b-form @submit.prevent="calculateMaksimumPinjaman">
        <div class="form-content-wrapper">
          <b-row>
            <b-col cols="9" sm="4">
              <h6 class="form-title">DATA ANGGOTA</h6>
            </b-col>
            <b-col cols="3" :hidden="$companyId == 'PGI' ? false : true">
              <b-badge
                :variant="pdfReadAnggota == false ? 'danger' : 'primary'"
                :hidden="seAnggota == null ? true : false"
                size="sm"
                @click="openModalSE(seAnggota, 'anggota', pdfReadAnggota)"
                v-b-tooltip.hover
                title="SE"
                name="jenisBarangViewBtn"
              >
                <i class="fa fa-info px-1"></i>
              </b-badge>
            </b-col>
          </b-row>
          <b-row class="no-gutters">
            <b-col cols="6" sm="3">
              <b-button
                @click="openSearchAnggotaModal"
                name="modalSearchAnggotaBtn"
                variant="pgiBtn"
                class="mr-2"
              >
                <i class="fa fa-search mr-2"></i>Pilih Anggota
              </b-button>
            </b-col>
            <b-col>
              <b-button @click="addAnggota" name="modalAddAnggotaBtn" variant="pgiBtn">
                <i class="fa fa-plus mr-2"></i>Anggota Baru
              </b-button>
            </b-col>
          </b-row>
          <StateDetailHandler
            :isLoading="stateListAnggota.isLoading"
            :isError="stateListAnggota.isError"
            :lines="5"
            @retry="getListAnggota(anggota.no)"
            class="mt-3"
          >
            <DetailSelectAnggota
              :anggota="anggota"
              :canEdit="IS_HAVE_PERMISSION_REQUEST_EDIT"
              :editAnggota="editAnggota"
              @refresh="getListAnggota"
              @preview-foto="openPreview"
              @wa="redirectToWhatsapp"
              @copy-wa="onCopyUrlWhatsApp"
              @edit="showEditAnggota"
              @detail="$bvModal.show('modal-detail-anggota')"
              @reset-password="$bvModal.show('modal-reset-password')"
              @edit-identitas="showEditIdentitas"
              @edit-anggota="showModalConfirmEditAnggota"
            />
          </StateDetailHandler>
          <div class="mb-4" v-show="valUmur == false">
            <span class="text-danger"
              ><i class="fa fa-warning"></i> Maaf umur nasabah belum 18 tahun, tidak
              bisa melakukan gadai.
            </span>
          </div>
        </div>
        <div class="form-content-wrapper">
          <h6 class="form-title">DATA EMAS</h6>
          <div class="card-wrapper emas-harga mb-4">
            <div class="cash-balance">
              <p class="mb-1">Harga Emas Sekarang</p>
              <h4 class="nominal mb-0">
                {{ "Rp. " + $helper.addThousandSeparator(hargaEmasSekarang) }}
              </h4>
              <span class="small text-muted">Per 24 karat per gram</span>
              <b-button class="d-block mt-2" variant="pgiBtn" @click="openModalJasa">
                Lihat Jasa
              </b-button>
            </div>
          </div>
          <b-row>
            <b-col cols="12" sm="5">
              <InputJenisEmas
                :input="input"
                :optJenisEmas="optJenisEmas"
                :pdfReadJenis="pdfReadJenis"
                :seJenis="seJenis"
                @openModalSE="openModalSE"
              />

              <!-- Logam Mulia (RETRO) 261 -->
              <div
                v-if="input.jenisEmas != null && isJenisEmasLmRetro(input.jenisEmas.id)"
              >
                <InputMerkEmas
                  :input="input"
                  :optMerkEmas="optMerkEmas"
                  :karatOpt="karatOpt"
                  :pdfReadMerk="pdfReadMerk"
                  :seMerk="seMerk"
                  :stateMerkEmas="stateMerkEmas"
                  @getMerkEmas="getMerkEmas"
                  @openModalSE="openModalSE"
                />

                <RadioAdaMerkPerusahaan :disabled="!IS_NON_ANTAM" :isAdaMerkPerusahaan="isAdaMerkPerusahaan" @isAdaMerkPerusahaan="(value) => { isAdaMerkPerusahaan = value }" />

                <InputTipeEmas
                  :input="input"
                  :optTipeEmas="optTipeEmas"
                  :tipeCreate="tipeCreate"
                  :pdfReadTipe="pdfReadTipe"
                  :seTipe="seTipe"
                  :stateTipeEmas="stateTipeEmas"
                  @getTipeEmas="getTipeEmas"
                  @openModalSE="openModalSE"
                />
                <!-- <InputCapEmas :input="input" :optCapEmas="optCapEmas" :cap="cap"/> -->
                <InputKemasanEmas :input="input" :optKemasanEmas="optKemasanEmas" />
                <InputBeratKering
                  :input="input"
                  :pdfReadBeratKering="pdfReadBeratKering"
                  :seBeratKering="seBeratKering"
                  :role="role"
                  @roundPersen="roundPersen"
                  @openModalSE="openModalSE"
                />
              </div>

              <!-- Logam Mulia (SCAN) 251 -->
              <div
                v-if="input.jenisEmas != null && isJenisEmasLmScan(input.jenisEmas.id)"
              >
                <InputMerkEmas
                  :input="input"
                  :optMerkEmas="optMerkEmas"
                  :karatOpt="karatOpt"
                  :pdfReadMerk="pdfReadMerk"
                  :seMerk="seMerk"
                  :stateMerkEmas="stateMerkEmas"
                  @getMerkEmas="getMerkEmas"
                  @openModalSE="openModalSE"
                />

                <InputTipeEmas
                  :input="input"
                  :optTipeEmas="optTipeEmas"
                  :tipeCreate="tipeCreate"
                  :pdfReadTipe="pdfReadTipe"
                  :seTipe="seTipe"
                  :stateTipeEmas="stateTipeEmas"
                  @getTipeEmas="getTipeEmas"
                  @openModalSE="openModalSE"
                />
                <!-- <InputCapEmas :input="input" :optCapEmas="optCapEmas" :cap="cap"/> -->
                <InputKemasanEmas :input="input" :optKemasanEmas="optKemasanEmas" />
              </div>

              <!-- Logam Mulia Retro 257 -->
              <div
                v-if="input.jenisEmas != null && isJenisEmasPerhiasan(input.jenisEmas.id)"
              >
                <!-- <InputMerkEmas 
                                    :input="input" 
                                    :optMerkEmas="optMerkEmas"
                                    :karatOpt="karatOpt"
                                    :pdfReadMerk="pdfReadMerk"
                                    :seMerk="seMerk"
                                    @openModalSE="openModalSE"
                                    /> -->
                <InputCapGosokKwi
                  :data="this"
                  :input="input"
                  :karatOpt="karatOpt"
                  :isSubmitting="isSubmitting"
                  :gosok="gosok"
                  :cap="cap"
                  :kwitansi="kwitansi"
                  :isAdaMerkPerusahaan="isAdaMerkPerusahaan"
                  @gosok="
                    (value) => {
                      gosok = value;
                    }
                  "
                  @cap="
                    (value) => {
                      cap = value;
                    }
                  "
                  @kwitansi="
                    (value) => {
                      kwitansi = value;
                    }
                  "
                  @isAdaMerkPerusahaan="
                    (value) => {
                      isAdaMerkPerusahaan = value;
                    }
                  "
                  :optCapEmas="optCapEmas"
                  :optKemasanEmas="optKemasanEmas"
                  :role="role"
                  :addBatu="addBatu"
                  :isBusy="isBusy"
                  :optPotonganTambahan="optPotonganTambahan"
                  :IS_REJECT_GADAI="IS_REJECT_GADAI"
                  @kalkulasiKarat="kalkulasiKarat"
                  @resetKarat="resetKarat"
                  @openModalSE="openModalSE"
                />

                <InputPointCapEmas :input="input" :cap="cap" :karatOpt="karatOpt" />
                <!-- <InputCapEmas :input="input" :optCapEmas="optCapEmas" :cap="cap"/> -->
                <InputKemasanEmas :input="input" :optKemasanEmas="optKemasanEmas" />

                <InputBeratKering
                  :input="input"
                  :pdfReadBeratKering="pdfReadBeratKering"
                  :seBeratKering="seBeratKering"
                  :role="role"
                  @roundPersen="roundPersen"
                  @openModalSE="openModalSE"
                />

                <InputBatu
                  :input="input"
                  :isBusy="isBusy"
                  :fieldsBatu="fieldsBatu"
                  @addBatu="addBatu"
                  @removeBatu="removeBatu"
                  :batuOpt="batuOpt"
                />

                <InputBeratTambahan
                  :input="input"
                  @roundPersenBeratTambahan="roundPersenBeratTambahan"
                  @checkBeratTambahan="
                    (value) => {
                      checkBeratTambahan = value;
                    }
                  "
                />

                <InputPotonganTambahan
                  :input="input"
                  :optPotonganTambahan="optPotonganTambahan"
                />
              </div>
            </b-col>
          </b-row>

          <p v-if="karatStatus == 1" class="text-success">
            * Emas dapat digadai, taksiran {{ karat }} karat
          </p>
          <p v-if="karatStatus == 0" class="text-danger">* {{ karat }}</p>

          <!-- <b-form-group label="Kondisi / Kerusakan / Keterangan Lainnya">
            <b-form-textarea
              id="textarea"
              v-model="input.keterangan"
              name="gadaiKondisi"
              rows="3"
              max-rows="6"
            ></b-form-textarea>
            <span class="smallText text-muted">
              * Dapat digunakan juga untuk mencatat detil barang gadai bilamana barang
              tidak ditemukan (Menggunakan pilihan ‘Lainnya’)”
            </span>
          </b-form-group> -->

          <b-form-group
            label="Spesifikasi Emas"
            v-if="input.jenisEmas != null && input.jenisEmas.id == 246"
          >
            <div v-if="optEmasSpekJenis.length == 0" class="text-muted">
              Tidak ada spesifikasi dari emas yang dipilih.
            </div>
            <b-form-checkbox-group
              class="checkbox-group"
              v-else
              v-model="input.spesifikasiBarangJenis"
              name="gadaiSpesifikasiJenisBarang"
            >
              <b-form-checkbox
                v-for="item in optEmasSpekJenis"
                v-bind:key="item.id"
                :value="item.id"
              >
                {{ item.name }}
              </b-form-checkbox>
            </b-form-checkbox-group>
          </b-form-group>

          <!-- <b-form-group label="Serial Number" v-if="input.jenisEmas != null && isJenisEmasLmScan(input.jenisEmas.id)">
                        <b-form-input v-model="input.imeiSn" name="gadaiSerialNumber"></b-form-input>
                    </b-form-group> -->

          <b-form-group>
            <div>
              <b-row>
                <b-col cols="10" sm="4">
                  <label class="mr-2" for="">Bentuk Perhiasan</label>
                  <span
                    v-if="optKelengkapanBarang.length != 0"
                    :hidden="$companyId == 'PGI' ? false : true"
                  >
                    <b-badge
                      :variant="pdfReadKelengkapan == false ? 'danger' : 'primary'"
                      :hidden="seKelengkapan == null ? true : false"
                      size="sm"
                      @click="
                        openModalSE(seKelengkapan, 'kelengkapan', pdfReadKelengkapan)
                      "
                      v-b-tooltip.hover
                      title="SE"
                      name="jenisBarangViewBtn"
                    >
                      <i class="fa fa-info px-1"></i>
                    </b-badge>
                  </span>
                </b-col>
                <b-col cols="2"> </b-col>
              </b-row>
            </div>

            <div v-if="optKelengkapanBarang.length == 0" class="text-muted">
              Tidak ada kelengkapan dari jenis barang yang dipilih.
            </div>

            <b-form-group v-else-if="isJenisEmasPerhiasan(input.jenisEmas.id)">
              <div v-for="item in optKelengkapanBarang" :key="item.id">
                <b-form-radio
                  v-model="input.kelengkapanBarang"
                  class="my-2"
                  :value="item.name"
                  name="gadaiKelengkapanBarang"
                >
                  {{ item.name }}
                </b-form-radio>
              </div>

              <div class="mt-4">
                <label class="mr-2">Kelengkapan Barang</label>
                <b-form-checkbox v-model="kwitansi" name="cekKwitansi">
                  Kwitansi
                </b-form-checkbox>
              </div>
            </b-form-group>

            <b-form-checkbox-group
              class="checkbox-group"
              v-else
              v-model="input.kelengkapanBarang"
              name="gadaiKelengkapanBarang"
            >
              <div class="d-block" v-for="item in optKelengkapanBarang" :key="item.id">
                <b-form-checkbox v-bind:key="item.id" :value="item.name">
                  {{ item.name }}
                </b-form-checkbox>
              </div>
            </b-form-checkbox-group>
          </b-form-group>
        </div>
        <div class="form-content-wrapper">
          <h6 class="form-title">DATA PENDUKUNG</h6>
          <div>
            <b-button
              variant="pgiBtn"
              class="mb-2"
              @click="addFotoPendukung"
              name="fotoPendukungAddBtn"
              ><i class="fa fa-plus mr-2"></i>Foto Pendukung</b-button
            >
            <div class="text-danger mt-2 mb-2" v-show="fotoPendukungError">
              * Foto Pendukung Maksimal {{ input.fotoPendukung.length }} Foto
            </div>
            <FotoPendukung
              v-for="item in input.fotoPendukung"
              v-bind:key="item.index"
              :fotoPendukung="item"
              :length="input.fotoPendukung.length"
              :minLength="minLengthFotoPendukung"
              :lat="lat"
              :long="long"
              @remove="removeFotoPendukung"
              @showModalCam="openModalCam"
              @showModalPreview="openModalPreview"
              isRemove
            />
          </div>
        </div>
        <div class="form-content-wrapper">
          <h6 class="form-title">PROMO</h6>
          <b-button variant="cancelBtn" @click="checkPromo" :disabled="isGettingPromo">
            {{ isGettingPromo ? "Mengambil..." : "Cek Promo yang Dapat Digunakan" }}
            <i class="fa fa-search ml-2"></i>
          </b-button>
          <div class="detail-promo-data mt-4" v-if="!isGettingPromo && isPromoRetrieved">
            <div v-if="optPromo.length == 0" class="text-danger">
              * Tidak ada promo yang bisa digunakan untuk pemilihan barang gadai ini.
            </div>
            <b-form-checkbox-group v-else v-model="input.promo" name="promoList" stacked>
              <b-form-checkbox
                class="mb-1"
                v-for="item in optPromo"
                v-bind:key="item.id"
                :value="item.id"
                >{{ item.name }}</b-form-checkbox
              >
            </b-form-checkbox-group>
          </div>
        </div>
        <div class="form-wrapper-btn submit-btn-wrapper">
          <b-button
            type="submit"
            name="gadaiSubmitBtn"
            variant="primary"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? "Menghitung..." : "Hitung" }}
          </b-button>
        </div>
      </b-form>
      <b-modal
        id="modal-input-anggota"
        body-class="modal-nopadding"
        size="xl"
        title="Input Anggota"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        :hide-header-close="isSubmitting"
      >
        <InputAnggota :isModal="modalAnggota" @submitModalAnggota="inputNewAnggota" :getListAnggota="getListAnggota" />
      </b-modal>
      <b-modal
        id="modal-edit-anggota"
        body-class="modal-nopadding"
        size="xl"
        title="Edit Anggota"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
        :hide-header-close="isSubmitting"
      >
        <EditAnggota
          :isModal="modalAnggota"
          :idAnggota="anggota.id"
          @updateModalAnggota="editNewAnggota"
          :getListAnggota="getListAnggota"
          :onToastSuccesEdit="onToastSuccesEdit"
        />
      </b-modal>
      <b-modal
        id="modal-detail-anggota"
        body-class="modal-nopadding"
        size="xl"
        title="Detail Anggota"
        no-close-on-backdrop
      >
        <DetailAnggota :isModal="modalAnggota" :idAnggota="anggota.id" />
        <template v-slot:modal-footer="{ cancel }">
          <b-button variant="secondary" name="cancelDetailAnggotaBtn" @click="cancel()">
            Tutup
          </b-button>
        </template>
      </b-modal>
      <ModalPilihAnggota @anggota-selected="selectAnggota" />
      <ModalRincian
        :namaLengkapBarang="namaLengkapBarang"
        :rincian="rincian"
        :isSubmitting="isSubmitting"
        :defaultMetodeGadai="input.metodeGadai"
        :defaultTenor="input.tenor"
        :defaultNilaiPinjaman="input.nilaiPinjaman"
        :jenisPinjaman="JENIS_PINJAMAN"
        @next="calculateConfirmation"
        :isRecalculating="isRecalculating" @change-metode="recalculateSkema"
        :useVoucher="input.useVoucher"
        :voucherCode="input.voucherCode"
      />
      <!-- <ModalRincian :namaLengkapBarang="namaLengkapBarang" :isEmas="true" :rincian="rincian" :isSubmitting="isSubmitting" :rekening="anggota.rekening" 
            @next="calculateConfirmation" :cashVirtual="cashVirtual" /> -->
      <ModalKonfirmasi
        :isSubmitting="isSubmitting"
        :nilaiPinjaman="input.nilaiPinjaman"
        :anggota="anggota"
        :rincian="rincian"
        :namaLengkapBarang="namaLengkapBarang"
        :metodeGadai="input.metodeGadai"
        :tenor="input.tenor"
        :angsuranPerBulan="angsuranPerBulan"
        @exec-submit="submitGadai"
      />
      <ModalSukses :rincian="rincian" @done="reset" />
      <ModalWebCam idWebcam="webcam-input-emas" @photoTaken="setResult" />
      <ModalPreview modalId="modal-preview-gadai" :fotoPreview="activeFotoPreview" />
      <b-modal
        id="modal-info-update"
        title="Update Data Anggota"
        hide-footer
        no-close-on-esc
        no-close-on-backdrop
      >
        <p>
          Mohon klik tombol Edit Anggota dan pastikan data anggota sudah sesuai dengan
          kartu identitas anggota!
        </p>
        <p>
          <strong>
            Pastikan alamat (kota, kecamatan, kelurahan) dan foto identitas sudah benar.
          </strong>
        </p>
        <p>
          Catatan: Bila data sudah benar semua dari awal, mohon untuk tetap menekan tombol
          Update ketika Edit Anggota.
        </p>
        <b-button variant="pgiBtn" class="mr-2" @click="showModalEditAnggota()">
          <i class="fa fa-pencil mr-2"></i>
          Edit Anggota
        </b-button>
      </b-modal>
      <ModalJasaEmas />
      <ModalResetPassword :nasabah="anggota" />

      <!-- MODAL SHOW SE -->
      <b-modal
        id="modal-SE-load"
        class="surat_edaran_modal"
        size="lg"
        title="Surat Edaran"
      >
        <b-table
          id="tableSE"
          bordered
          hover
          show-empty
          :fields="fields"
          :busy="false"
          :items="activeSE"
          :currentPage="currentPage"
          :perPage="perPage"
          :borderless="true"
          :head-variant="null"
          responsive
          class="mb-3"
        >
          <template v-slot:header :hidden="true"></template>
          <template v-slot:cell(se)="row">
            <iframe
              width="100%"
              height="700"
              allowfullscreen
              :src="$baseFilePath + row.item.filepath"
              frameborder="0"
            ></iframe>
          </template>
        </b-table>
        <template>
          <div class="progress" :hidden="progress == 100 || progress == 0 ? true : false">
            <div
              class="progress-bar"
              role="progressbar"
              :style="{ width: progress + '%' }"
              :aria-valuenow="progress"
              aria-valuemin="0"
              aria-valuemax="100"
            >
              {{ progress }}%
            </div>
          </div>
        </template>
        <br />
        <div class="pagination-wrapper d-flex align-items-center justify-content-center">
          <b-pagination
            class="mb-0"
            :disabled="interval"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
            @input="onPageChange"
          ></b-pagination>
        </div>
        <template #modal-footer>
          <div class="w-100"></div>
        </template>
      </b-modal>

      <!-- MODAL SHOW SE -->
      <b-modal id="modal-SE" class="surat_edaran_modal" size="lg" title="Surat Edaran">
        <b-table
          bordered
          hover
          show-empty
          :fields="fields"
          :busy="false"
          :items="activeSE"
          :currentPage="currentPage"
          :perPage="perPage"
          :borderless="true"
          :head-variant="null"
          responsive
          class="mb-3"
        >
          <template v-slot:header :hidden="true"></template>
          <template v-slot:cell(se)="row">
            <iframe
              width="100%"
              height="700"
              allowfullscreen
              :src="$baseFilePath + row.item.filepath"
              frameborder="0"
            ></iframe>
          </template>
        </b-table>

        <div class="pagination-wrapper d-flex align-items-center justify-content-center">
          <b-pagination
            class="mb-0"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            aria-controls="my-table"
            @input="page"
          ></b-pagination>
        </div>
        <template #modal-footer>
          <div class="w-100"></div>
        </template>
      </b-modal>
      <b-modal
        id="modal-update-telepon"
        title="Mohon update no telepon anggota"
        hide-header-close
        no-close-on-esc
        no-close-on-backdrop
      >
        <p class="mb-0">Mohon untuk mengupdate no telepon anggota terlebih dahulu !</p>
        <template v-slot:modal-footer="{ cancel }">
          <b-button variant="secondary" name="closeDetailBtn" @click="cancel()">
            Lanjutkan Gadai
          </b-button>
        </template>
      </b-modal>
    </b-card>

    <ModalIdentitas
      :isModal="modalAnggota"
      :idAnggota="anggota.id"
      :dataAnggota="anggota"
      :getListAnggota="getListAnggota"
      :isEdit="isModalEditAnggota"
      titleInformasiEdit="Perubahan identitas dapat dilakukan melalui tombol Edit Identitas di depan."
    />

    <ModalConfirm id="modal-request-edit-no-handphone" title="Konfirmasi Perubahan No Handphone Anggota"
      :isSubmitting="isLoadingReqApproval" desc="Apakah Anda yakin ingin ubah no handphone anggota ini?"
      @submit="handleApproval('no-handphone')" />

    <ModalConfirm id="modal-request-edit-name" title="Konfirmasi Perubahan Nama Anggota" :isSubmitting="isLoadingReqApproval"
      desc="Apakah Anda yakin ingin ubah nama anggota ini?" @submit="handleApproval('name')" />
  </div>
</template>

<script>
import ModalPilihAnggota from "../ModalPilihAnggota";
import ModalRincian from "../ModalRincian";
import ModalKonfirmasi from "../ModalKonfirmasi";
import ModalSukses from "../ModalSukses";
import InputAnggota from "../../master/anggota/InputAnggota";
import EditAnggota from "../../master/anggota/EditAnggota";
import DetailAnggota from "../../master/anggota/DetailAnggota";
import FotoPendukung from "../../../components/webcam/FotoPendukung";
import ModalWebCam from "../../../components/webcam/ModalWebCam";
import ModalPreview from "../../../components/webcam/ModalPreview";
import ModalJasaEmas from "../../../components/jasaEmas/JasaEmas";
import ModalResetPassword from "../../master/anggota/ModalResetPassword.vue";
import InputJenisEmas from "../../../atoms/emas/inputJenisEmas.vue";
import InputMerkEmas from "../../../atoms/emas/inputMerkEmas.vue";
import InputTipeEmas from "../../../atoms/emas/inputTipeEmas.vue";
import InputCapEmas from "../../../atoms/emas/inputCapEmas.vue";
import InputKemasanEmas from "../../../atoms/emas/inputKemasanEmas.vue";
import InputBeratKering from "../../../atoms/emas/inputBeratKering.vue";
import InputCapGosokKwi from "../../../atoms/emas/inputGosokCapKwi.vue";
import InputBatu from "../../../atoms/emas/inputBatu.vue";
import InputBeratTambahan from "../../../atoms/emas/inputBeratTambahan.vue";
import InputPotonganTambahan from "../../../atoms/emas/inputPotonganTambahan.vue";
import InputPointCapEmas from "../../../atoms/emas/inputPointCapEmas.vue";
import RadioAdaMerkPerusahaan from "../../../atoms/emas/RadioAdaMerkPerusahaan.vue";
import Timer from "@/components/gadai/Timer";
import { enumJenisEmas } from "../../../shared/utils";
import ModalIdentitas from "../ModalIdentitas.vue";
import StateDetailHandler from '@/components/common/StateDetailHandler'
import DetailSelectAnggota from '@/components/anggota/DetailSelectAnggota'
import CONSTANTS from '@/constants'

export default {
  name: "input-gadai-emas",
  components: {
    ModalPilihAnggota,
    ModalRincian,
    ModalKonfirmasi,
    ModalSukses,
    InputAnggota,
    EditAnggota,
    DetailAnggota,
    FotoPendukung,
    ModalWebCam,
    ModalPreview,
    ModalJasaEmas,
    ModalResetPassword,
    InputJenisEmas,
    InputMerkEmas,
    InputTipeEmas,
    InputCapEmas,
    InputKemasanEmas,
    InputBeratKering,
    InputCapGosokKwi,
    InputBatu,
    InputBeratTambahan,
    InputPotonganTambahan,
    InputPointCapEmas,
    RadioAdaMerkPerusahaan,
    Timer,
    ModalIdentitas,
    StateDetailHandler,
    DetailSelectAnggota
  },
  data() {
    return {
      initStatus: 0,
      isGettingPromo: false,
      isPromoRetrieved: false,
      isSubmitting: false,
      isRecalculating: false,
      shouldResetSelections: false,
      angsuranPerBulan: 0,

      karatStatus: null,
      karat: null,

      lat: 0,
      long: 0,

      modalAnggota: true,

      role: null,
      editAnggota: false,
      anggota: {
        id: null,
        nama: "-",
        no: "-",
        jenisBarang: "-",
        jenisIdentitas: "-",
        noIdentitas: "-",
        noHp: "-",
        noRumah: "-",
        alamat: "-",
        isComplete: false,
        shouldUpdate: false,
        tanggalLahir: "-",
        fotoKtp: "",
      },

      valUmur: true,

      rincian: {
        hargaBarang: 0,
        maksimumPinjaman: 0,
        minimumPinjaman: 0,
        perhitunganPromo: null,
        perhitunganKondisi: {},
        perhitunganSpek: [],
        perhitunganBonusGadaiPertama: {},
        perhitunganStatusAnggota: {},
        biayaAdmin: 0,
        noFaktur: "",
        showAlertNoFakturGanda: "false",
        alertNoFakturGanda: "",
        alertGadai: "emas",
        batu: [],
        beratTambahan: null,
        disburseType: 0,
      },

      namaLengkapBarang: "",

      warnaBatuOpt: [],

      hargaEmasSekarang: 0,
      cap: true,

      i: 0,
      kwitansi: false,
      gosok: true,
      isAdaMerkPerusahaan: false,
      checkBeratTambahan: false,
      input: {
        jenisEmas: null,
        merkEmas: null,
        tipeEmas: null,
        karatEmas: null,
        spesifikasiBarangJenis: [],
        kelengkapanBarang: [],
        beratKering: null,
        beratBasah: null,
        jumlah: 1,
        keterangan: "",
        promo: [],
        nilaiPinjaman: 0,
        warnaBatu: null,
        metodeGadai: null,
        tenor: null,

        imeiSn: null,

        fotoPendukung: [
          {
            index: 0,
            id: 0,
            checkFotoBarangPendukung: false,
            fotoBarangPendukungPlaceholder: "Choose a file",
            fotoBarangPendukung: null,
            fotoBarangPendukungBase64: null,
            activeFotoPendukungBase64: null,
          },
        ],

        batu: [],
        beratTambahan: null,
        potonganTambahan: [],

        capEmas: null,
        kemasanEmas: null,
        pointCapEmas: null,

        voucherCode: "",
        useVoucher: false,
        disburseType: 0,
      },

      tipeCreate: null,

      indexFotoPendukung: 1,
      fotoPendukungError: false,
      activeFotoPendukungIndex: null,
      activeFotoPreviewIndex: null,
      minLengthFotoPendukung: 1,
      activeFotoPreview: "",

      jenisIdentitas: [],
      requiredForDataKerabatAndPihakLain: false,
      tarifSelected: null,
      selected: null,

      optCapEmas: [],
      optKemasanEmas: [],
      optKaratEmas: [],
      optJenisEmas: [],
      optMerkEmas: [],
      optTipeEmas: [],
      optEmasSpekJenis: [],
      optPromo: [],
      optKelengkapanBarang: [],
      karatOpt: [],
      batuOpt: [
        { name: "2/100", value: 0.02 },
        { name: "3/100", value: 0.03 },
        { name: "4/100", value: 0.04 },
        { name: "5/100", value: 0.05 },
        { name: "6/100", value: 0.06 },
        { name: "7/100", value: 0.07 },
        { name: "8/100", value: 0.08 },
        { name: "9/100", value: 0.09 },
        { name: "10/100", value: 0.1 },
        { name: "15/100", value: 0.15 },
        { name: "20/100", value: 0.2 },
        { name: "25/100", value: 0.25 },
        { name: "30/100", value: 0.3 },
        { name: "35/100", value: 0.35 },
        { name: "40/100", value: 0.4 },
        { name: "45/100", value: 0.45 },
        { name: "50/100", value: 0.5 },
        { name: "55/100", value: 0.55 },
        { name: "60/100", value: 0.6 },
        { name: "65/100", value: 0.65 },
        { name: "70/100", value: 0.7 },
        { name: "75/100", value: 0.75 },
        { name: "80/100", value: 0.8 },
        { name: "85/100", value: 0.85 },
        { name: "90/100", value: 0.9 },
        { name: "1", value: 1 },
        { name: "1,25", value: 1.25 },
        { name: "1,50", value: 1.5 },
        { name: "1,75", value: 1.75 },
        { name: "2", value: 2 },
        { name: "2,5", value: 2.5 },
        { name: "3", value: 3 },
        { name: "3,5", value: 3.5 },
        { name: "4", value: 4 },
        { name: "4,5", value: 4.5 },
        { name: "5", value: 5 },
      ],
      optPotonganTambahan: [],
      fieldsBatu: [
        { key: "ukuran", label: "Ukuran" },
        { key: "jumlah", label: "Jumlah" },
        { key: "action", label: "Aksi" },
      ],

      cabangId: "",

      progress: 0,
      interval: false,
      intervalId: null,

      seAnggota: null,
      seJenis: null,
      seMerk: null,
      seTipe: null,
      seBeratKering: null,
      seVolume: null,
      seKelengkapan: null,
      seWarnaBatu: null,

      pdfReadAnggota: true,
      pdfReadJenis: true,
      pdfReadMerk: true,
      pdfReadTipe: true,
      pdfReadBeratKering: true,
      pdfReadVolume: true,
      pdfReadKelengkapan: true,
      pdfReadWarnaBatu: true,

      activeSE: null,

      slide: 0,
      sliding: null,

      fields: [{ key: "se", label: "Surat Edaran" }],
      isBusy: true,

      currentPage: 1,
      perPage: 1,
      rows: null,

      startTime: null,
      elapsedTime: 0,
      isModalEditAnggota: false,
      stateMerkEmas: {
        isLoading: false,
        error: null,
      },
      stateTipeEmas: {
        isLoading: false,
        error: null,
      },
      isFirstRender: true,
      isLoadingReqApproval: false,
      selectedRow: null,
      stateListAnggota: {
          isLoading: false,
          isError: false,
      }
    };
  },
  computed: {
    JENIS_PINJAMAN() {
      return CONSTANTS.GADAI.JENIS.EMAS;
    },
    formattedTime() {
      const minutes = Math.floor(this.elapsedTime / 60000);
      const seconds = Math.floor((this.elapsedTime % 60000) / 1000);
      return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    },
    isRunning() {
      return this.intervalId !== null;
    },
    IS_NON_ANTAM() {
      const merkEmas = this.input.merkEmas
      return !!(merkEmas && merkEmas.name.includes('Non Antam'))
    },
    IS_REJECT_GADAI() {
      const jenisEmas = this.input.jenisEmas;
      if (jenisEmas && jenisEmas.id == enumJenisEmas.PERHIASAN) {
          return this.gosok && (!this.cap || !this.isAdaMerkPerusahaan)
      }
      return false
    },
    IS_HAVE_PERMISSION_REQUEST_EDIT() {
      const hasPermissionEdit = this.$helper.hasPermissionMenuChildren('EDN')
      return hasPermissionEdit;
    },
  },
  methods: {
    //----------------- Fungsi Inisialisasi -----------------
    init() {
      this.initStatus = 0;
      this.role = localStorage.getItem("role");
      this.editAnggota = localStorage.getItem("menuChildren").includes("EDA")
        ? true
        : false;

      let getJenisEmas = this.$axios.get(`barang-jenis/emas`).then((response) => {
        this.optJenisEmas = response.data;
      });

      let getHargaEmasSekarang = this.$axios
        .get("harga-emas/current")
        .then((response) => {
          this.hargaEmasSekarang = response.data.id;
        });

      let seAnggota = this.$axios
        .get("surat-edaran/list/?menu=anggota&jenis=anggota")
        .then((response) => {
          if (response.data.length != 0) {
            this.seAnggota = response.data;
            for (var se of this.seAnggota) {
              if (se.isViewSE == "false") {
                this.pdfReadAnggota = false;
              }
            }
          }
        });

      let seBeratKering = this.$axios
        .get("surat-edaran/list/?menu=beratKering&jenis=beratKering")
        .then((response) => {
          if (response.data.length != 0) {
            this.seBeratKering = response.data;
            for (var se of this.seBeratKering) {
              if (se.isViewSE == "false") {
                this.pdfReadBeratKering = false;
              }
            }
          }
        });

      let seVolume = this.$axios
        .get("surat-edaran/list/?menu=volume&jenis=volume")
        .then((response) => {
          if (response.data.length != 0) {
            this.seVolume = response.data;
            for (var se of this.seVolume) {
              if (se.isViewSE == "false") {
                this.pdfReadVolume = false;
              }
            }
          }
        });

      let getPotonganTambahanEmas = this.$axios
        .get("spesifikasi-emas/selection")
        .then((response) => {
          this.optPotonganTambahan = response.data;
        });

      if (localStorage.getItem("gadaiFromSimulasi") != null) {
        if (localStorage.getItem("anggotaFromSimulasi") != null) {
          this.selectAnggota(JSON.parse(localStorage.getItem("anggotaFromSimulasi")));
          localStorage.removeItem("anggotaFromSimulasi");
        }

        let data = JSON.parse(localStorage.getItem("gadaiFromSimulasi"));

        this.input.jenisEmas = data.jenisEmas;
        this.input.merkEmas = data.merkEmas;
        this.input.tipeEmas = data.tipeEmas;
        this.input.capEmas = data.capEmas;
        this.input.kemasanEmas = data.kemasanEmas;
        this.input.metodeGadai = data.metodeGadai || null;
        this.input.tenor = data.tenor || null;
        this.input.nilaiPinjaman = data.nilaiPinjaman || 0;

        if (this.isJenisEmasLmRetro(data.jenisEmas.id)) {
          this.input.jenisEmas = data.jenisEmas;
          this.input.merkEmas = data.merkEmas;
          this.input.tipeEmas = data.tipeEmas;
          this.input.kemasanEmas = data.kemasanEmas;
          this.input.capEmas = data.capEmas;
          this.input.beratKering = data.beratKering;
          this.isAdaMerkPerusahaan = data.isAdaMerkPerusahaan;
        }

        if (this.isJenisEmasLmScan(data.jenisEmas.id)) {
          this.input.jenisEmas = data.jenisEmas;
          this.input.merkEmas = data.merkEmas;
          this.input.tipeEmas = data.tipeEmas;
          this.input.kemasanEmas = data.kemasanEmas;
          this.input.capEmas = data.capEmas;
        }

        if (this.isJenisEmasPerhiasan(data.jenisEmas.id)) {
          this.input.jenisEmas = data.jenisEmas;
          this.input.merkEmas = data.merkEmas;
          this.input.karatEmas = data.karatEmas;
          this.input.kemasanEmas = data.kemasanEmas;
          this.input.capEmas = data.capEmas;
          this.input.beratKering = data.beratKering;

          this.gosok = data.gosok;
          this.cap = data.cap;
          this.kwitansi = data.kwitansi;
          this.isAdaMerkPerusahaan = data.isAdaMerkPerusahaan;

          if (!this.$helper.isNullOrEmpty(data.karatOpt)) {
            this.karatOpt = data.karatOpt;
          }
          this.input.kelengkapanBarang = data.kelengkapanBarang;
          this.input.pointCapEmas = data.pointCapEmas;
          this.input.batu = data.batu;
          this.input.potonganTambahan = data.potonganTambahan;
        }
        if (data.beratTambahan != null) {
          this.checkBeratTambahan = true;
          this.input.beratTambahan = data.beratTambahan;
        }
      }

      // localStorage.removeItem('gadaiFromSimulasi');

      navigator.geolocation.getCurrentPosition(
        (position) => {
          this.lat = position.coords.latitude;
          this.long = position.coords.longitude;
        },
        () => {
        }
      );

      Promise.all([
        getJenisEmas,
        getHargaEmasSekarang,
        seAnggota,
        seBeratKering,
        seVolume,
        getPotonganTambahanEmas,
      ])
        .then(() => {
          this.initStatus = 1;
          this.toggleBusy();
        })
        .catch(() => {
          this.initStatus = -1;
        });
      this.cabangId = this.$helper.getCabangId();
    },

    addBatu() {
      this.i++;
      this.input.batu.push({
        index: this.i,
        ukuran: null,
        jumlah: 0,
        customUkuran: null,
      });
    },

    removeBatu(index) {
      this.input.batu = this.input.batu.filter((item) => item.index != index);
    },

    reset() {
      this.$bvModal.hide("modal-sukses");
      this.$bvModal.hide("modal-konfirmasi");
      this.$bvModal.hide("modal-rincian");

      this.anggota.id = null;
      this.anggota.nama = "-";
      this.anggota.no = "-";
      this.anggota.jenisIdentitas = "-";
      this.anggota.noIdentitas = "-";
      this.anggota.noHp = "-";
      this.anggota.noRumah = "-";
      this.anggota.alamat = "-";
      this.anggota.statusPembayaran = "";
      this.anggota.identitas = [];

      this.input.jenisEmas = null;
      this.input.merkEmas = null;
      this.input.tipeEmas = null;
      this.input.beratKering = null;
      this.input.beratBasah = null;
      this.input.karatEmas = null;
      this.input.spesifikasiBarangJenis = [];
      this.input.kelengkapanBarang = [];
      this.input.keterangan = "";
      this.input.promo = [];
      this.input.disburseType = 0;
      this.input.fotoPendukung = [
        {
          id: 0,
          index: this.indexFotoPendukung,
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Choose a file",
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
        },
      ];

      this.input.batu = [];
      this.input.potonganTambahan = [];

      this.checkBeratTambahan = false;
      this.input.beratTambahan = null;

      this.karat = null;
      this.karatStatus = null;
      this.karatOpt = [];

      window.scroll(0, 0);

      this.valUmur = true;

      this.input.capEmas = null;
      this.input.kemasanEmas = null;
      this.input.pointCapEmas = null;

      this.input.imeiSn = null;

      this.input.metodeGadai = null;
      this.input.tenor = null;
      this.input.nilaiPinjaman = 0;
      this.angsuranPerBulan = 0;
    },

    addAnggota() {
      this.isModalEditAnggota = false;
      this.$bvModal.show("modal-input-anggota");
    },

    showEditAnggota() {
      this.isModalEditAnggota = true;
      this.$bvModal.show('modal-edit-anggota')
    },
    
    showEditIdentitas() {
      this.isModalEditAnggota = false;
      this.$bvModal.show('modal-identitas-list-c')
    },

    openSearchAnggotaModal() {
      this.$bvModal.show("modal-pilih-anggota");
    },

    selectAnggota(item) {
      this.anggota.id = item.id;
      this.anggota.nama = item.nama;
      this.anggota.no = item.no;
      // this.anggota.jenisIdentitas = item.jenisIdentitas.name
      // this.anggota.noIdentitas = item.noIdentitas
      if (item.identitas && item.identitas.length > 0) {
        this.anggota.jenisIdentitas = item.identitas[0].jenisIdentitas
        this.anggota.noIdentitas = item.identitas[0].noIdentitas
      }
      this.anggota.noHp = item.noHp;
      this.anggota.noRumah = item.noRumah;
      this.anggota.alamat = item.alamat;
      this.anggota.isComplete = item.isComplete;
      this.anggota.shouldUpdate = item.shouldUpdateData;
      this.anggota.shouldUpdatePhone = item.shouldUpdatePhone;
      this.anggota.statusPembayaran = item.statusPembayaran;
      this.anggota.identitas = item.identitas;

      this.anggota.tanggalLahir = item.tanggalLahir;

      this.anggota.fotoKtp = item.detail.fotoKtp;

      this.valUmur = this.$helper.validasiUmurNasabah(this.anggota.tanggalLahir);
      if (item.shouldUpdatePhone == true) {
        this.$bvModal.show("modal-update-telepon");
      }
      if (this.valUmur == false) {
        this.$helper.toastErr(
          this,
          "Maaf umur nasabah belum 18 tahun, tidak bisa melakukan gadai."
        );
        return;
      }

      if (this.anggota.shouldUpdate == true) {
        this.$bvModal.hide("modal-pilih-anggota");
        this.$bvModal.show("modal-info-update");
      } else {
        this.$bvModal.hide("modal-pilih-anggota");
      }
    },

    showModalEditAnggota() {
      this.$bvModal.show("modal-edit-anggota");
      this.$bvModal.hide("modal-info-update");
    },

    checkPromo() {
      if (this.input.jenisEmas !== null && this.input.beratKering !== null) {
        let path =
          "gadai-emas/promo?tipeId=" +
          this.input.jenisEmas.id +
          "&cabangId=" +
          this.cabangId +
          "&berat=" +
          this.input.beratKering;

        this.input.promo = [];

        this.isGettingPromo = true;
        this.$axios
          .get(path)
          .then((response) => {
            this.optPromo = response.data;
            this.isPromoRetrieved = true;
          })
          .catch((error) => {
            this.$helper.parseError(this, error);
          })
          .finally(() => {
            this.isGettingPromo = false;
          });
      } else if (this.input.jenisEmas !== null && this.input.tipeEmas !== null) {
        let path =
          "gadai-emas/promo?tipeId=" +
          this.input.jenisEmas.id +
          "&cabangId=" +
          this.cabangId +
          "&berat=" +
          this.input.tipeEmas.berat;

        this.input.promo = [];

        this.isGettingPromo = true;
        this.$axios
          .get(path)
          .then((response) => {
            this.optPromo = response.data;
            this.isPromoRetrieved = true;
          })
          .catch((error) => {
            this.$helper.parseError(this, error);
          })
          .finally(() => {
            this.isGettingPromo = false;
          });
      } else {
        this.$helper.toastErr(
          this,
          "Mohon lengkapi karat emas dan berat terlebih dahulu"
        );
      }
    },

    recalculateSkema(metodeGadai) {
      this.input.metodeGadai = metodeGadai;
      this.isRecalculating = true;
      Promise.resolve(this.calculateMaksimumPinjaman()).then(success => {
        if (!success) return;
        const skema = metodeGadai == 'angsuran' ? 'angsuran' : 'non angsuran';
        this.$helper.toastSucc(this, `Harga telah disesuaikan ke skema ${skema}.`, 'Penyesuaian Harga');
      }).finally(() => {
        this.isRecalculating = false;
      });
    },
    calculateMaksimumPinjaman() {
      if (this.anggota.id == null) {
        this.$helper.toastErr(this, "Mohon memilih anggota terlebih dahulu!");
        return;
      }

      if (this.anggota.shouldUpdatePhone == true) {
        this.$helper.toastErr(this, "Mohon update no telepon anggota terlebih dahulu!");
        return;
      }
      // if (this.input.pointCapEmas <3) {
      //     this.$helper.toastErr(this, "Angka Cap Emas harus 3 digit")
      //     return
      // }

      if (this.input.jenisEmas == null) {
        this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!");
        return;
      }

      if (this.isJenisEmasLmScan(this.input.jenisEmas.id)) {
        if (this.input.merkEmas == null) {
          this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!");
          return;
        }
        if (this.input.tipeEmas == null) {
          this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!");
          return;
        }
      }

      if (this.isJenisEmasPerhiasan(this.input.jenisEmas.id)) {
        if (this.gosok == true && this.cap == false) {
          this.$helper.toastErr(
            this,
            "Tidak dapat menggadaikan emas ini! (Gosokan hilang tanpa cap)"
          );
          return;
        }

        if (this.gosok == true && this.isAdaMerkPerusahaan == false) {
          this.$helper.toastErr(
            this,
            "Tidak dapat menggadaikan emas ini! (tidak ada merk perusahaan)"
          );
          return;
        }

        for (var data of this.input.batu) {
          if (data.ukuran == null) {
            this.$helper.toastErr(this, "Mohon lengkapi data batu terlebih dahulu!");
            return;
          }

          if (data.jumlah == 0) {
            this.$helper.toastErr(this, "Jumlah Batu tidak boleh 0!");
            return;
          }
        }

        if (this.input.beratKering == null) {
          this.$helper.toastErr(this, "Mohon input berat kering terlebih dahulu!");
          return;
        }
        if (this.cap == true && this.input.karatEmas == null) {
          this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!");
          return;
        }

        const isValid = this.validateSizes(this.input.batu);
        if (isValid) {
        } else {
          this.$helper.toastErr(this, "Terdapat Ukuran Batu yang sama");
          return;
        }

        if (this.checkBeratTambahan == true) {
          if (this.input.beratTambahan == null || this.input.beratTambahan == 0) {
            this.$helper.toastErr(this, "Mohon isi Potongan Berat tambahan");
            return;
          }
        }
        if (this.$helper.isNullOrEmpty(this.input.kelengkapanBarang)) {
          this.$helper.toastErr(this, "Mohon pilih Kelengkapan");
          return;
        }
        if (this.input.pointCapEmas.length < 3) {
          this.$helper.toastErr(this, "Angka Cap Emas harus 3 digit");
          return;
        }
      }

      if (this.isJenisEmasLmRetro(this.input.jenisEmas.id)) {
        if (this.input.merkEmas == null) {
          this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!");
          return;
        }
        if (this.input.tipeEmas == null) {
          this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!");
          return;
        }
        if (this.input.beratKering == null) {
          this.$helper.toastErr(this, "Mohon lengkapi data emas terlebih dahulu!");
          return;
        }
      }

      this.roundPersen();

      // Check if there is at least one picture attached
      if (
        this.input.fotoPendukung.length == 1 &&
        this.$helper.isNullOrEmpty(this.input.fotoPendukung[0].activeFotoPendukungBase64)
      ) {
        this.$helper.toastErr(this, "Mohon upload minimal 1 gambar!");
        return;
      }

      // Check if all photo row has been filled
      for (var i = 0; i < this.input.fotoPendukung.length; i++) {
        let item = this.input.fotoPendukung[i];
        if (this.$helper.isNullOrEmpty(item.activeFotoPendukungBase64)) {
          this.$helper.toastErr(
            this,
            "Terdapat upload gambar yang kosong, periksa kembali!"
          );
          return;
        }
      }

      // Bila umur belum 18 tahun
      if (this.valUmur == false) {
        return this.$helper.toastErr(
          this,
          "Maaf umur nasabah belum 18 tahun, tidak bisa melakukan gadai."
        );
      }

      let payload = this.preparePayload();

      this.isSubmitting = true;
      return this.$axios
        .post("gadai-emas/submit", payload)
        .then((response) => {
          let data = response.data;
          this.rincian = data;
          this.rincian.batu = [];
          this.rincian.beratTambahan = null;
          this.rincian.input = this.input;

          if (response.data.noFakturSuspectGanda != null) {
            this.rincian.showAlertNoFakturGanda = true;
            this.rincian.alertGadai = "elek";
            this.rincian.alertNoFakturGanda = response.data.noFakturSuspectGanda;
          }

          // Arrange nama lengkap barang
          if (this.isJenisEmasLmScan(this.input.jenisEmas.id)) {
            this.namaLengkapBarang =
              "Emas " +
              this.input.jenisEmas.name +
              " - " +
              this.input.merkEmas.name +
              " " +
              this.input.tipeEmas.name;
          } else if (this.isJenisEmasLmRetro(this.input.jenisEmas.id)) {
            const adaMerkPerusahaanText = this.isAdaMerkPerusahaan ? ' - Ada Merk Perusahaan' : ' - Tidak Ada Merk Perusahaan'
                    
            this.namaLengkapBarang =
              "Emas " +
              this.input.jenisEmas.name +
              adaMerkPerusahaanText +
              " - " +
              this.input.merkEmas.name +
              " " +
              this.input.tipeEmas.name +
              " - " +
              this.input.beratKering +
              " Gram";
          } else if (this.input.jenisEmas.id == 252) {
            let kwitansi = "";
            if (this.cap == true) {
              kwitansi = " ( Ada Cap Karat )";
            }
            this.namaLengkapBarang =
              "Emas " +
              this.input.jenisEmas.name +
              kwitansi +
              ". Total Berat Keseluruhan: " +
              this.input.beratKering +
              " Gram, Total Potongan Berat : " +
              data.beratBatu +
              " Gram. Taksiran " +
              data.karatEmas +
              " karat";
          } else if (this.isJenisEmasPerhiasan(this.input.jenisEmas.id)) {
            this.namaLengkapBarang = `Emas ${this.input.jenisEmas.name}, ${this.input.karatEmas.name}. Angka Cap: ${this.input.pointCapEmas}`;

            this.namaLengkapBarang +=
              this.gosok == false ? " Gosokan Tidak Hilang" : " Gosokan Hilang";
            this.namaLengkapBarang += this.cap == true ? ", Ada Cap Karat" : ", Tidak Ada Cap Karat";
            this.namaLengkapBarang += this.isAdaMerkPerusahaan ? ", Ada Merk Perusahaan" : ", Tidak Ada Merk Perusahaan";

            this.namaLengkapBarang += `\nBerat Kering : ${this.input.beratKering} gr. Potongan Berat : ${data.beratBatu} gr. Berat Bersih : ${data.beratEmas} gr.`;

            let namaBarang = `Emas ${this.input.jenisEmas.name}, ${this.input.karatEmas.name}. Angka Cap: ${this.input.pointCapEmas}`;
            let gosokCapKwitansi =
              this.gosok == false ? " Gosokan Tidak Hilang" : " Gosokan Hilang";
            gosokCapKwitansi += this.cap == true ? ", Ada Cap Karat" : ", Tidak Ada Cap Karat";
            gosokCapKwitansi += this.isAdaMerkPerusahaan ? ", Ada Merk Perusahaan" : ", Tidak Ada Merk Perusahaan";
            let batuBarang = `\nBerat Kering : ${this.input.beratKering} gr. Potongan Berat : ${data.beratBatu} gr. Berat Bersih : ${data.beratEmas} gr.`;

            this.rincian.namaBarang = namaBarang;
            this.rincian.gosokCapKwitansi = gosokCapKwitansi;
            this.rincian.batuBarang = batuBarang;

            this.rincian.batu = this.input.batu;
            if (this.checkBeratTambahan == true) {
              this.rincian.beratTambahan = this.input.beratTambahan;
            }
          } else {
            this.namaLengkapBarang =
              "Emas " +
              this.input.jenisEmas.name +
              ", " +
              this.input.merkEmas.name +
              " - " +
              this.input.beratKering +
              " Gram";
          }
          this.$bvModal.show("modal-rincian");
          return true;
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },

    kalkulasiKarat() {
      // if (this.input.merkEmas == null) {
      //     this.$helper.toastErr(this, "Mohon pilih merk emas!");
      //     return;
      // }
      this.isSubmitting = true;
      const params = {
        merkId: this.input.merkEmas.id,
        adaCap: this.cap,
        gosokanHilang: this.gosok,
        adaLogoPerusahaan: this.isAdaMerkPerusahaan,
      }

      this.$axios
        .get("gadai-emas/tipe-retro", { params })
        .then((response) => {
          this.karatOpt = response.data;
          if (this.karatOpt.length === 1) {
            this.input.karatEmas = this.karatOpt[0];
          }
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
          this.isSubmitting = false;
        })
        .finally(() => {
          this.isSubmitting = false;
        });
    },
    resetKarat() {
      this.karatOpt = [];
      this.input.karatEmas = null;
    },

    calculateConfirmation(data) {
      this.input.useVoucher = data.useVoucher;
      this.input.voucherCode = data.voucherCode;
      this.input.disburseType = data.disburseType;
      this.input.metodeGadai = data.metodeGadai;
      this.input.tenor = data.tenor;
      this.angsuranPerBulan = data.angsuranPerBulan || 0;

      if (data.nilaiPinjaman % 50000 != 0) {
        this.$helper.toastErr(this, "Pinjaman hanya boleh dalam kelipatan Rp 50.000");
      } else {
        let payload = this.preparePayload(data);

        this.isSubmitting = true;
        this.$axios
          .post("gadai-emas/submit", payload)
          .then((response) => {
            let data = response.data;
            this.rincian = data;

            if (this.input.metodeGadai == 'angsuran' && Array.isArray(data.simulasiAngsuran) && data.simulasiAngsuran.length > 0) {
              this.angsuranPerBulan = data.simulasiAngsuran[0].cicilan;
            }

            if (this.isJenisEmasPerhiasan(this.input.jenisEmas.id)) {
              let namaBarang = `Emas ${this.input.jenisEmas.name}, ${this.input.karatEmas.name}. Angka Cap: ${this.input.pointCapEmas}`;
              let gosokCapKwitansi =
                this.gosok == false ? " Gosokan Tidak Hilang" : " Gosokan Hilang";
              gosokCapKwitansi += this.cap == true ? ", Ada Cap Karat" : ", Tidak Ada Cap Karat";
              gosokCapKwitansi += this.isAdaMerkPerusahaan ? ", Ada Merk Perusahaan" : ", Tidak Ada Merk Perusahaan";
              let batuBarang = `\nBerat Kering : ${this.input.beratKering} gr. Potongan Berat : ${data.beratBatu} gr. Berat Bersih : ${data.beratEmas} gr.`;

              this.rincian.namaBarang = namaBarang;
              this.rincian.gosokCapKwitansi = gosokCapKwitansi;
              this.rincian.batuBarang = batuBarang;

              this.rincian.batu = this.input.batu;
            }

            this.$bvModal.show("modal-konfirmasi");
          })
          .catch((error) => {
            this.$helper.parseError(this, error);
          })
          .finally(() => {
            this.isSubmitting = false;
          });
      }
    },

    validateSizes(sizes) {
      const uniqueSizes = new Set();

      for (const item of sizes) {
        const size = item.ukuran.value;

        if (size != 99) {
          if (uniqueSizes.has(size)) {
            return false;
          }
        }

        uniqueSizes.add(size);
      }

      return true;
    },

    submitGadai() {
      let data = {
        nilaiPinjaman: this.input.nilaiPinjaman,
        useVoucher: this.input.useVoucher,
        voucherCode: this.input.voucherCode,
        disburseType: this.input.disburseType,
      };

      let payload = this.preparePayload(data, true);

      this.isSubmitting = true;
      this.$axios
        .post("gadai-emas/submit", payload, { timeout: 300000 })
        .then((response) => {
          let data = response.data;
          this.rincian.noFaktur = data.noFaktur;
          this.$bvModal.show("modal-sukses");
        })
        .catch((error) => {
          this.$helper.parseError(this, error);
        })
        .finally(() => {
          this.resetTime();
          this.isSubmitting = false;
        });
    },

    preparePayload(data = null, finalizePayment = false) {
      let json = {
        nasabahId: this.anggota.id,
        cabangId: this.cabangId,
        finalizePayment: finalizePayment,
        keterangan: this.input.keterangan,
        voucherCode: this.input.voucherCode,
        disburseType: this.input.disburseType,
        core: {},
      };

      if (this.isJenisEmasLmScan(this.input.jenisEmas.id)) {
        json.core.jenisId = this.input.jenisEmas.id;
        json.core.merkId = this.input.merkEmas ? this.input.merkEmas.id : null;
        json.core.tipeId = this.input.tipeEmas.id;
        json.core.jenisKemasanId =
          this.input.kemasanEmas != null ? this.input.kemasanEmas.id : null;
        json.core.capId = this.input.capEmas ? this.input.capEmas.id : null;
        json.core.beratKering = null;
        json.core.dataPerhiasan = null;
        // json.imeiSn = this.input.imeiSn
      }

      if (this.isJenisEmasPerhiasan(this.input.jenisEmas.id)) {
        json.core.jenisId = this.input.jenisEmas.id;
        json.core.merkId = this.input.merkEmas ? this.input.merkEmas.id : null;
        json.core.tipeId = this.input.karatEmas.id;
        json.core.jenisKemasanId =
          this.input.kemasanEmas != null ? this.input.kemasanEmas.id : null;
        json.core.capId = this.input.capEmas ? this.input.capEmas.id : null;
        json.core.beratKering = this.input.beratKering;
        json.core.dataPerhiasan = {
          gosokanHilang: this.gosok,
          adaCap: this.cap,
          adaKwitansi: this.kwitansi,
          beratTambahan:
            this.checkBeratTambahan == true ? this.input.beratTambahan : null,
          kelengkapan: this.input.kelengkapanBarang,
          pointCapEmas: this.input.pointCapEmas,
          listBatu:
            this.input.batu.length != null
              ? Array.from(this.input.batu, (item) => ({
                  jumlah: item.jumlah,
                  ukuran: item.ukuran.value,
                }))
              : null,
          listSpekEmas: this.input.potonganTambahan,
          adaLogoPerusahaan: this.isAdaMerkPerusahaan,
        };
      }

      if (this.isJenisEmasLmRetro(this.input.jenisEmas.id)) {
        json.core.jenisId = this.input.jenisEmas.id;
        json.core.merkId = this.input.merkEmas ? this.input.merkEmas.id : null;
        json.core.tipeId = this.input.tipeEmas.id;
        json.core.jenisKemasanId =
          this.input.kemasanEmas != null ? this.input.kemasanEmas.id : null;
        json.core.capId = this.input.capEmas ? this.input.capEmas.id : null;
        json.core.beratKering = this.input.beratKering;
        json.core.dataPerhiasan = null;
        json.core.dataPerhiasan = {
          adaLogoPerusahaan: this.isAdaMerkPerusahaan,
        }
      }

      if (data != null) {
        this.input.nilaiPinjaman = data.nilaiPinjaman;
        this.input.voucherCode = data.voucherCode;
        this.input.useVoucher = data.useVoucher;
        this.input.disburseType = data.disburseType;

        json.jumlahPinjaman = data.nilaiPinjaman;
      }

      if (finalizePayment) {
        let jsonFoto = [];
        this.input.fotoPendukung.forEach(function (entry) {
          jsonFoto.push(entry.activeFotoPendukungBase64);
        });

        json.foto = jsonFoto;
      }

      if (this.input.metodeGadai == 'angsuran') {
        json.scheme = 1;
        json.term = this.input.tenor;
      } else {
        json.scheme = 0;
      }

      return json;
    },

    inputNewAnggota() {
      this.$bvModal.hide("modal-confirm-input");
      this.$bvModal.hide("modal-input-anggota");
      this.$helper.toastSucc(this, "Anggota nasabah baru telah berhasil dibuat!");
    },

    editNewAnggota(dataAnggota) {
      this.$bvModal.hide("modal-confirm-edit");
      this.$bvModal.hide("modal-edit-anggota");

      this.anggota.id = dataAnggota.idAnggota;
      this.anggota.nama = dataAnggota.nama;
      this.anggota.noHp = dataAnggota.noHp;
      this.anggota.noRumah = dataAnggota.noRumah;
      this.anggota.alamat = dataAnggota.alamat;
      this.anggota.isComplete = dataAnggota.isComplete;
      this.anggota.shouldUpdatePhone = dataAnggota.shouldUpdatePhone;
      this.anggota.identitas = dataAnggota.identitas;

      this.anggota.no = dataAnggota.noAnggota;
      // this.anggota.noIdentitas = dataAnggota.noIdentitas
    },

    openModalCam(index) {
      this.activeFotoPendukungIndex = index;
      this.$bvModal.show("webcam-input-emas");
    },

    openModalPreview(index) {
      this.activeFotoPreviewIndex = index;
      let idx = this.input.fotoPendukung.findIndex(
        (item) => item.index == this.activeFotoPreviewIndex
      );
      this.activeFotoPreview = this.input.fotoPendukung[idx].fotoBarangPendukungBase64;
      this.$bvModal.show("modal-preview-gadai");
    },

    async setResult(result) {
      let formattedDate = this.$helper.formatTanggalDMY();

      let img = new Image();
      img.src = result;
      img.onload = () => {
        let canvas = document.createElement("canvas");
        let ctx = canvas.getContext("2d");
        canvas.setAttribute("width", img.width);
        canvas.setAttribute("height", img.height);
        ctx.drawImage(img, 0, 0);
        ctx.font = "14pt Arial";
        ctx.fillStyle = "#ffffff";
        ctx.fillText(formattedDate, 10, img.height - 40);
        ctx.strokeText(formattedDate, 10, img.height - 40);
        ctx.fillText(this.lat + " " + this.long, 10, img.height - 10);
        ctx.strokeText(this.lat + " " + this.long, 10, img.height - 10);
        let newBase64Str = canvas.toDataURL("image/jpeg", 0.9);

        let idx = this.input.fotoPendukung.findIndex(
          (item) => item.index == this.activeFotoPendukungIndex
        );
        this.input.fotoPendukung[idx].fotoBarangPendukungBase64 = newBase64Str;
        this.input.fotoPendukung[idx].activeFotoPendukungBase64 = newBase64Str;
        this.input.fotoPendukung[idx].fotoBarangPendukungPlaceholder = "Foto dari Kamera";
        this.input.fotoPendukung[idx].checkFotoBarangPendukung = true;
      };
    },

    //----------------- Fungsi Tambah Hapus Data Foto Pendukung -----------------

    addFotoPendukung() {
      if (this.input.fotoPendukung.length < 30) {
        this.input.fotoPendukung.unshift({
          id: 0,
          index: this.indexFotoPendukung,
          checkFotoBarangPendukung: false,
          fotoBarangPendukungPlaceholder: "Choose a file",
          fotoBarangPendukung: null,
          fotoBarangPendukungBase64: null,
          activeFotoPendukungBase64: null,
        });
        this.indexFotoPendukung++;
      } else {
        this.fotoPendukungError = true;
      }
    },

    removeFotoPendukung(index) {
      this.input.fotoPendukung = this.input.fotoPendukung.filter(
        (item) => item.index != index
      );
      this.fotoPendukungError = false;
    },

    roundPersen() {
      if (Number(this.input.beratKering) > 1000) {
        this.input.beratKering = Number(0).toFixed(1);
      } else {
        this.input.beratKering = Number(this.input.beratKering).toFixed(2);

        if (this.input.jenisEmas.id == 246) {
          if (
            this.input.merkEmas != null &&
            this.input.merkEmas.id != null &&
            this.input.beratBasah != 0 &&
            this.input.beratBasah != null &&
            this.input.beratKering != 0
          ) {
            let payload = new FormData();
            payload.append("jenisId", 246);
            payload.append("merkId", this.input.merkEmas.id);
            payload.append("berat", this.input.beratKering);
            payload.append("beratKering", this.input.beratKering);
            payload.append("beratBasah", this.input.beratBasah);

            this.$axios
              .post("gadai-emas/cek_emas", payload)
              .then((response) => {
                let data = response.data;
                this.karatStatus = 1;
                this.karat = data.karat;
              })
              .catch((error) => {
                this.karatStatus = 0;
                this.karat = error.response.data.reason;
              });
          }

          if (this.input.merkEmas == null) {
            this.karatStatus = 0;
            this.karat = "Mohon pilih Merk Emas terlebih dahulu!";
          }

          if (this.input.beratKering == 0) {
            this.karatStatus = 0;
            this.karat = "Mohon isi Berat Kering";
          }

          if (this.input.beratBasah == 0) {
            this.karatStatus = 0;
            this.karat = "Mohon isi Volume";
          }

          if (this.input.beratKering == 0 && this.input.beratBasah == 0) {
            this.karatStatus = 0;
            this.karat = "Mohon isi Berat kering & volume";
          }
        }
      }
    },

    roundPersenBeratBasah() {
      if (Number(this.input.beratBasah) > 99) {
        this.input.beratBasah = Number(0).toFixed(1);
      } else {
        this.input.beratBasah = Number(this.input.beratBasah).toFixed(2);

        if (this.input.jenisEmas.id == 246) {
          if (
            this.input.merkEmas != null &&
            this.input.merkEmas.id != null &&
            this.input.beratKering != 0 &&
            this.input.beratKering != null &&
            this.input.beratBasah != 0
          ) {
            let payload = new FormData();
            payload.append("jenisId", 246);
            payload.append("merkId", this.input.merkEmas.id);
            payload.append("berat", this.input.beratKering);
            payload.append("beratKering", this.input.beratKering);
            payload.append("beratBasah", this.input.beratBasah);

            this.$axios
              .post("gadai-emas/cek_emas", payload)
              .then((response) => {
                let data = response.data;
                this.karatStatus = 1;
                this.karat = data.karat;
              })
              .catch((error) => {
                this.karatStatus = 0;
                this.karat = error.response.data.reason;
              });
          }

          if (this.input.merkEmas == null) {
            this.karatStatus = 0;
            this.karat = "Mohon pilih Merk Emas terlebih dahulu!";
          }

          if (this.input.beratKering == 0) {
            this.karatStatus = 0;
            this.karat = "Mohon isi Berat Kering";
          }

          if (this.input.beratBasah == 0) {
            this.karatStatus = 0;
            this.karat = "Mohon isi Volume";
          }

          if (this.input.beratKering == 0 && this.input.beratBasah == 0) {
            this.karatStatus = 0;
            this.karat = "Mohon isi Berat kering & Volume";
          }
        }
      }
    },

    roundPersenBeratTambahan() {
      if (Number(this.input.beratTambahan) > 99) {
        this.input.beratTambahan = Number(0).toFixed(1);
      } else {
        this.input.beratTambahan = Number(this.input.beratTambahan).toFixed(2);
      }
    },

    openModalJasa() {
      this.$bvModal.show("modal-jasa-emas");
    },

    openModalSE(se, jenis, isViewSE) {
      this.activeSE = se;
      this.rows = se.length;

      if (isViewSE == false) {
        let payload = new FormData();

        let id = 0;
        if (jenis == "tipe") {
          id = this.input.karatEmas.id;
          payload.append("id", jenis + id);
        }
        if (jenis == "anggota") {
          payload.append("id", "anggota");
        }
        this.$axios.post(`surat-edaran/view`, payload).then(() => {
          if (jenis == "anggota") {
            this.pdfReadAnggota = true;
          }
          if (jenis == "tipe") {
            this.pdfReadTipe = true;
          }
        });

        this.$bvModal.show("modal-SE-load");
      } else {
        this.$bvModal.show("modal-SE");
      }
    },

    onSlideStart() {
      this.sliding = true;
    },

    onSlideEnd() {
      this.sliding = false;
    },

    //----------------- Fungsi Lain-lain -----------------
    toggleBusy() {
      if (this.isBusy == true) this.isBusy = false;
      else this.isBusy = true;
    },

    onPageChange() {
      this.interval = true;

      this.intervalId = null;
      this.progress = 0;
      this.intervalId = setInterval(() => {
        this.progress += 10;
        if (this.progress >= 100) {
          clearInterval(this.intervalId);
        }
      }, 500);

      setTimeout(this.page, 5000);
    },

    page() {
      this.interval = false;
      let prevLimit = null;
      let limit = null;
      prevLimit = (this.currentPage - 1) * 1 + 1;
      limit = (this.currentPage - 1) * 1 + 1;
      if (limit > this.rows) limit = this.rows;
      this.totalViewText =
        "Menampilkan " + prevLimit + " - " + limit + " dari " + this.rows + " entri";
    },

    start() {
      if (!this.isRunning) {
        this.startTime = Date.now() - this.elapsedTime;
        this.intervalId = setInterval(() => {
          this.elapsedTime = Date.now() - this.startTime;
        }, 10);
      }
    },
    pause() {
      clearInterval(this.intervalId);
      this.intervalId = null;
    },
    resetTime() {
      this.elapsedTime = 0;
      this.startTime = null;
      this.startTime = Date.now() - this.elapsedTime;
      this.intervalId = setInterval(() => {
        this.elapsedTime = Date.now() - this.startTime;
      }, 10);
      localStorage.removeItem("stopwatch");
    },
    isJenisEmasLmScan(id) {
      return id == enumJenisEmas.LMSCAN;
    },
    isJenisEmasLmRetro(id) {
      return id == enumJenisEmas.LMRETRO;
    },
    isJenisEmasPerhiasan(id) {
      return id == enumJenisEmas.PERHIASAN;
    },
    openPreview(foto) {
      this.activeFotoPreview = foto;
      this.$bvModal.show("modal-preview-gadai");
    },
    redirectToWhatsapp(number) {
      if (!number || number === '-' || number.trim() === '') {
          return;
      }

      const formatted = number.startsWith('0') 
      ? '62' + number.substring(1) 
      : number;

      window.open(`https://wa.me/${formatted}`, '_blank');
    },

    onCopyUrlWhatsApp(number) {
      if (!number || number === '-' || number.trim() === '') {
          console.error('Nomor HP tidak valid untuk disalin.');
          return;
      }

      const formatted = number.startsWith('0') 
          ? '62' + number.substring(1) 
          : number;
      
      const urlToCopy = `https://wa.me/${formatted}`;

      navigator.clipboard.writeText(urlToCopy).then(() => {
          this.$helper.toastSucc(this, "Link WhatsApp berhasil disalin!")
      }).catch(err => {
          this.$helper.toastErr(this, "Gagal menyalin link.")
          console.error('Gagal menyalin teks: ', err);
      });
    },
    getListAnggota(noAnggota) {
      this.stateListAnggota.isLoading = true;
      this.stateListAnggota.isError = false;

      this.$axios.get(`nasabah/findForGadai`, {
          params: {
              query: noAnggota,
              searchBy: 3,
              page: 0,
              size: 10,
          }
      }).then(response => {
          const data = response.data.data[0];
          this.selectAnggota(data);
      })
      .catch(error => {
          this.$helper.parseError(this, error)
          this.stateListAnggota.isError = true;
      })
      .finally(() => {
          this.stateListAnggota.isLoading = false;
      })
    },
    onToastSuccesEdit() {
      this.$helper.toastSucc(this, "Identitas berhasil diupdate");
    },
    getMerkEmas() {
      const idJenisEmas = this.input.jenisEmas.id
      this.stateMerkEmas.isLoading = true;
      this.optMerkEmas = [];
      
      this.$axios.get(`barang-merk/jenis/${idJenisEmas}`).then((response) => {
        this.optMerkEmas = response.data;
        if (this.optMerkEmas.length === 1 && this.input.merkEmas == null) {
          this.input.merkEmas = this.optMerkEmas[0];
        }
      }).catch((error) => {
        const errorMessage = error.response.data.reason || error.response.data.error;
        this.stateMerkEmas.error = errorMessage;
      }).finally(() => {
        this.stateMerkEmas.isLoading = false;
      }) 
    },
    getTipeEmas() {
      const idMerkEmas = this.input.merkEmas.id
      this.stateTipeEmas.isLoading = true;
      this.optTipeEmas = [];
      
      this.$axios.get(`barang-tipe-v2/merk/${idMerkEmas}?sortByBerat=true`).then((response) => {
        this.optTipeEmas = response.data.types;
      }).catch((error) => {
        const errorMessage = error.response.data.reason || error.response.data.error;
        this.stateTipeEmas.error = errorMessage;
      }).finally(() => {
        this.stateTipeEmas.isLoading = false;
      }) 
    },
    validateAdaMerkPerusahaanInRetro() {
      if (this.isFirstRender) {
        const gadaiFromSimulasi = JSON.parse(localStorage.getItem("gadaiFromSimulasi")) || {}

        if (gadaiFromSimulasi.isAdaMerkPerusahaan !== undefined) {
          this.isAdaMerkPerusahaan = gadaiFromSimulasi.isAdaMerkPerusahaan
        } else {
          const merkEmas = this.input.merkEmas
          this.isAdaMerkPerusahaan = !(merkEmas && merkEmas.name.includes("Non Antam"))
        }

        this.isFirstRender = false
        return
      }

      const merkEmas = this.input.merkEmas
      if (merkEmas && merkEmas.name.includes('Non Antam')) {
          this.isAdaMerkPerusahaan = false;
      } else {
          this.isAdaMerkPerusahaan = true;
      }
    },
    showModalConfirmEditAnggota(value) {
      this.selectedRow = value;
      
      if (this.$helper.isNullOrEmpty(value.notes)) {
        this.$helper.toastErr(this, "Mohon isi alasan terlebih dahulu.")
        return
      }

      if (value.key === 'no-handphone') {
        const isOldValueX = value.oldValue && String(value.oldValue).toLowerCase().startsWith('x');
        
        if (!isOldValueX && this.$helper.isNullOrEmpty(value.attachments)) {
          this.$helper.toastErr(this, "Mohon isi foto pendukung terlebih dahulu.")
          return
        }
          
        this.$bvModal.show('modal-request-edit-no-handphone')
      }

      if (value.key === 'name') {
        this.$bvModal.show('modal-request-edit-name')
      }
    },
    handleApproval(field) {
      const value = this.selectedRow;
      const cabangId = localStorage.getItem('activeCabangId');

      const payload = new URLSearchParams();

      if (field === 'no-handphone') {
        const attachmentsValue = Array.isArray(value.attachments) 
          ? JSON.stringify(value.attachments) 
          : value.attachments;
                
        payload.append('attachments', attachmentsValue);
      }

      let dataType = '';
      if (field === 'no-handphone') {
        dataType = 'no_handphone_sekarang'
      }

      if (field === 'name') {
        dataType = 'nama'
      }

      this.isLoadingReqApproval = true

      const params = {
        dataType: dataType,
        value: value.newValue,
        note: value.notes,
        nasabahId: value.row.id,
        cabangId: cabangId,
      };

      const headers = {
        'Content-Type': 'application/x-www-form-urlencoded',
      };

      this.$axios.post('/nasabah/request-update-data', payload, { 
        params: params, 
        headers: headers 
      })
      .then(response => {
        this.$helper.toastSucc(this, response.data.name)
        if (field === 'no-handphone') {
          this.$bvModal.hide('modal-approval-no-handphone')
          this.$bvModal.hide('modal-request-edit-no-handphone')
        }

        if (field === 'name') {
          this.$bvModal.hide('modal-approval-name')
          this.$bvModal.hide('modal-request-edit-name')
        }
      })
      .catch(error => {
        this.$helper.parseError(this, error)
      })
      .finally(() => {
        this.isLoadingReqApproval = false;
      })
    }
  },

  watch: {
    "input.jenisEmas": function (newVal) {
      if (this.shouldResetSelections == true) {
        this.input.merkEmas = null;
        this.input.tipeEmas = null;
        this.input.capEmas = null;
        this.input.kemasanEmas = null;
        this.optMerkEmas = [];
        this.optTipeEmas = [];
        this.optCapEmas = [];
        this.optKemasanEmas = [];
        this.input.beratKering = null;
        this.input.beratBasah = null;
        this.input.warnaBatu = null;

        this.input.spesifikasiBarangJenis = [];
        this.optKelengkapanBarang = [];
        this.input.kelengkapanBarang = [];

        this.optPromo = [];
        this.input.promo = [];
        this.isPromoRetrieved = false;

        (this.seJenis = null),
          (this.seMerk = null),
          (this.seTipe = null),
          (this.seWarnaBatu = null);
        this.seKelengkapan = null;

        this.karat = null;
        this.karatStatus = null;
        this.input.karatEmas = null;
        this.karatOpt = [];

        this.input.imeiSn = null;
        this.isAdaMerkPerusahaan = false;
      }

      if (newVal == null) {
        return;
      }

      if (newVal.id != null) {
        this.getMerkEmas();

        this.$axios.get(`barang-jenis/${newVal.id}`).then((response) => {
          if (response.data.suratEdaran.length != 0) {
            this.seJenis = response.data.suratEdaran;

            for (var se of this.seJenis) {
              if (se.isViewSE == "false") {
                this.pdfReadJenis = false;
              }
            }
          } else {
            this.seJenis = null;
          }
        });

        this.warnaBatuOpt = [];
        this.$axios
          .get(`barang-jenis/spesifikasi?jenisId=${newVal.id}`)
          .then((response) => {
            let data = response.data;
            if (data.pengurangan.length != 0) {
              for (var item of data.pengurangan) {
                this.warnaBatuOpt.push(item);
              }
            }
            if (data.penambahan.length != 0) {
              for (var item of data.penambahan) {
                this.warnaBatuOpt.push(item);
              }
            }
            this.warnaBatuOpt.sort((a, b) => a.name.localeCompare(b.name));
          });

        this.$axios
          .get(`barang-jenis/kelengkapan?jenisId=${newVal.id}`)
          .then((response) => {
            this.optKelengkapanBarang = [];
            for (var x of response.data) {
              if (x.isActive == true) {
                this.optKelengkapanBarang.push({
                  id: x.id,
                  name: x.name,
                  se: x.suratEdaran.length != 0 ? x.suratEdaran : null,
                });
              }
            }
          });

        this.$axios
          .get("/surat-edaran/list/?menu=kelengkapan" + newVal.id + "&jenis=kelengkapan")
          .then((response) => {
            if (response.data.length != 0) {
              this.seKelengkapan = response.data;
              for (var file of this.seKelengkapan) {
                if (file.isViewSE == "false") {
                  this.pdfReadKelengkapan = false;
                }
              }
            }
          });
      }
    },

    "input.merkEmas": function (newVal) {
      if (this.shouldResetSelections == true) {
        this.input.tipeEmas = null;
        this.input.capEmas = null;
        this.input.kemasanEmas = null;
        this.input.pointCapEmas = null;

        this.optPromo = [];
        this.input.promo = [];
        this.isPromoRetrieved = false;
        this.optTipeEmas = [];
        this.optCapEmas = [];
        this.optKemasanEmas = [];
      }
      this.shouldResetSelections = true;
      if (newVal == undefined) {
        return;
      }
      if (newVal.id != undefined) {
        this.$axios.get(`barang-merk/${newVal.id}`).then((response) => {
          if (response.data.suratEdaran.length != 0) {
            this.seMerk = response.data.suratEdaran;
            for (var se of this.seMerk) {
              if (se.isViewSE == "false") {
                this.pdfReadMerk = false;
              }
            }
          } else {
            this.seMerk = null;
          }

          if (response.data.kondisi[0].suratEdaran.length != 0) {
            let suratEdaranKondisi = [];
            for (var se of response.data.kondisi[0].suratEdaran) {
              suratEdaranKondisi.push(se);
              if (se.isViewSE == "false") {
                this.pdfReadKondisi = false;
              }
            }

            this.seKondisi = suratEdaranKondisi;
            this.seKondisiDariMerk = true;
          } else {
            this.seKondisi = null;
          }
        });

        this.getTipeEmas();
        this.$axios.get(`cap-emas/selections?merkId=${newVal.id}`).then((response) => {
          this.optCapEmas = response.data;
        });

        this.$axios
          .get(`kemasan-emas/selections?merkId=${newVal.id}`)
          .then((response) => {
            this.optKemasanEmas = response.data;
          });
      }

      if (this.input.jenisEmas.id == 246) {
        this.roundPersen();
        this.roundPersenBeratBasah();
      }

      if (this.input.jenisEmas.id == enumJenisEmas.LMRETRO) {
        this.validateAdaMerkPerusahaanInRetro();
      }
    },

    "input.tipeEmas": function (newVal) {
      if (this.shouldResetSelections == true) {
        this.optPromo = [];
        this.input.promo = [];
        this.isPromoRetrieved = false;
      }

      this.shouldResetSelections = true;

      if (newVal == null) {
        return;
      }

      if (newVal != null) {
        this.$axios.get(`barang-tipe-v2/${newVal.id}`).then((response) => {
          let date = null;
          if (response.data.createdAt != null) {
            date = response.data.createdAt;
            this.tipeCreate = this.$helper.formatTanggalDMY(date);
          } else {
            this.tipeCreate = null;
          }
          if (response.data.suratEdaran.length != 0) {
            let suratEdaran = [];
            let suratEdaranKondisi = [];
            let suratEdaranTahun = [];
            for (var se of response.data.suratEdaran) {
              if (se.jenis == null || se.jenis == "tipe") {
                suratEdaran.push(se);
                if (se.isViewSE == "false") {
                  this.pdfReadTipe = false;
                }
              }
              if (se.jenis == "kondisi") {
                suratEdaranKondisi.push(se);
                if (se.isViewSE == "false") {
                  this.pdfReadKondisi = false;
                }
                this.seKondisiDariMerk = false;
              }
              if (se.jenis == "tahun") {
                suratEdaranTahun.push(se);
                if (se.isViewSE == "false") {
                  this.pdfReadTahun = false;
                }
              }
            }
            this.seTipe = suratEdaran;
            if (suratEdaranKondisi != null && suratEdaranKondisi.length != 0) {
              this.seKondisi = suratEdaranKondisi;
            }
            this.seTahun = suratEdaranTahun;
            this.showSeKondisi = true;
          } else {
            this.seTipe = null;
          }

          if (response.data.berat != null) {
            this.input.tipeEmas.berat = response.data.berat;
          }
        });
      }
    },

    "input.warnaBatu": function (newVal) {
      if (newVal == null) {
        return;
      }
      if (newVal.id != null) {
        if (newVal.suratEdaran.length != 0) {
          this.seWarnaBatu = newVal.suratEdaran;

          for (var se of this.seWarnaBatu) {
            if (se.isViewSE == "false") {
              this.pdfReadWarnaBatu = false;
            }
          }
        } else {
          this.seWarnaBatu = null;
        }
      }
    },
  },

  created() {
    if (localStorage.getItem("gadaiEmasActive") == "true") {
      this.resetTime();
      this.start();
      this.init();
    } else {
      this.$router.push("/");
    }
  },
};
</script>
